import script from "./Terms_and_conditions.vue?vue&type=script&setup=true&lang=js"
export * from "./Terms_and_conditions.vue?vue&type=script&setup=true&lang=js"

import "./Terms_and_conditions.vue?vue&type=style&index=0&id=aa7e7234&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa7e7234"]])

export default __exports__